import "simplemde-markdown-editor/dist/simplemde.min.css";
import SimpleMDE from "simplemde-markdown-editor/dist/simplemde";

const NS = 'MarkdownEditor';

export default function MarkdownEditor($timeout) {
  "ngInject";

  function link(scope, element, attrs) {

    var toolbar = [
      "bold", "italic", "|",
      "unordered-list", "ordered-list", "|", "link",
      "preview", "side-by-side", "fullscreen"
    ];

    if (attrs.showenabled !== undefined) {
      toolbar.push("|");
      toolbar.push({
        name: "enabled",
        action: function () {
          scope.md.toggleEnabled();
        },
        className: 'mdi mdi-checkbox-blank-outline right',
        title: 'Enabled'
      });
    }


    scope.md.mde = new SimpleMDE({
      element: element.children()[0],
      toolbar: toolbar,
      spellChecker: false,
      openLinksInNewWindow: true
    });

    scope.md.mde.render();
    scope.md.isEnabled = true;
    scope.md.setEnabled(scope.md.isEnabled);

    //Model 2way binding
    scope.md.mde.codemirror.on("change", function () {
      scope.md.codeChanged();
    });

    scope.$watch('md.model', function (newValue) {
      newValue = convertLineBreaksToMarkDown(newValue);
      if (newValue == null) {
        newValue = "";
      }
      if (newValue !== scope.md.mde.value()) {
        scope.md.mde.codemirror.doc.setValue(newValue);
        $timeout(function () {
          scope.md.mde.codemirror.refresh();
        }, 500);

      }
    });

    scope.$watch('md.visible', function (newValue) {
      if (newValue) {
        $timeout(function () {
          scope.md.mde.codemirror.refresh();
        }, 100);
      }
    });

    scope.$watch('md.toolbar', function (newValue) {
      if (newValue != null) {
        if (newValue) {
          element.removeClass('hide-toolbar');
        } else {
          element.addClass('hide-toolbar');
        }
      }
    });

    scope.$watch('md.enabled', function (newValue) {
      if (typeof newValue === 'boolean' && newValue !== scope.md.isEnabled) {
        scope.md.toggleEnabled();
      } else { }
    });
  }

  function convertLineBreaksToMarkDown(mdValue) {
    if (mdValue) {
      return mdValue.replace(/<br ?\/?>/g, "\n");
    }
  }


  return {
    restrict: 'E',
    replace: false,
    bindToController: {
      enabled: '=',
      model: '=',
      showenabled: '=',
      visible: '=',
      toolbar: '='
    },
    controller,
    link,
    scope: true,
    controllerAs: 'md',
    template: '<textarea aria-label="markdown"></textarea>'
  }
};

// just exported for unit tests
export function controller($timeout, $scope) {
  "ngInject";

  var md = this;

  // lifecycle hook
  md.$onInit = function () {
    md.toggleEnabled = toggleEnabled;
    md.setEnabled = setEnabled;
    md.codeChanged = codeChanged;
    md.refresh = function () {
    };
  };


  function codeChanged() {
    var newVal = this.mde.value();
    if (newVal !== md.model) {
      if (!$scope.$$phase) { // To check if $Digest is already in progress. then dont call the apply function.
        $scope.$apply(function () {
          md.model = newVal;
        });
      }

    }
  }

  function toggleEnabled() {
    setEnabled(!this.isEnabled);
    if (this.isEnabled !== md.enabled) {
      $scope.$apply(function () {
        md.enabled = md.isEnabled;
      });
    }
  }

  function setEnabled(value) {
    md.isEnabled = value;
    var menuElem = angular.element(md.mde.toolbarElements.enabled);
    if (md.isEnabled) {
      menuElem.addClass('enabled');
      md.mde.codemirror.setOption('readOnly', false);
    } else {
      menuElem.removeClass('enabled');
      md.mde.codemirror.setOption('readOnly', 'nocursor');
    }
  }
}

